/**
 * @file components/SecureDropWidget/component.js
 * @copyright 2018 CBC/Radio-Canada. All rights reserved.
 */

import ImageLinkWidget from "../ImageLinkWidget/component";

const SecureDropWidget = (props) => {
    return <ImageLinkWidget {...props} />;
};

export default SecureDropWidget;
